import axios from "axios";
import {
  CookieData,
  createCookieDate,
  JTCookies,
} from "../utils/storage/cookies";

const USER_BASE_URL = process.env.REACT_APP_API_URL;
const WALLET_BASE_URL = process.env.REACT_APP_WALLET_URL;

export const instance = (server = "user", token, isFile) => {
  const base = axios.create({
    baseURL: server === "user" ? USER_BASE_URL : WALLET_BASE_URL,
    timeout: 150000,
    headers: {
      ...(!isFile && { "Content-Type": "application/json" }),
      withCredentials: true,
      // ...(isFile && {"Content-Type": "multipart/form-data",}),
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    },
  });

  const methods = ["post", "patch", "put"];
  base.interceptors.request.use(async (config) => {
    const cookies = new JTCookies(document);
    const token = await cookies.getCookie("authToken").catch(() => null);
    if (token) {
      config.headers = {
        "Content-Type": "application/json",
        ...config.headers,
        withCredentials: true,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  });

  base.interceptors.response.use((config) => {
    if (methods.includes(config.config.method)) {
      const cookies = new JTCookies(document);
      const data = config.data?.data;
      try {
        if (data?.token) {
          const authCookie = new CookieData(
            "authToken",
            data["token"],
            createCookieDate(data["expiresIn"])
          );
          const emailCookie = new CookieData(
            "email",
            data["email"],
            createCookieDate(data["expiresIn"])
          );
          cookies.saveCookies([authCookie, emailCookie]);
        }
      } catch (error) {
      }
    }
    return config;
  });

  return base;
};

export const next = (e) => {
  throw new Error(
    e.response?.data ? e.response.data.message : "Something went wrong"
  );
};

export { USER_BASE_URL as baseUrl };
